<!--
 * @Author: Yuan Cong <email: wso2848303@163.com> <tel: 15821618224>
 * @Date: 2021-01-26 15:34:46
 * @LastEditors: Wang Bin <email: binnuo1109@163.com> <tel: 13937670602>
 * @LastEditTime: 2022-02-17 12:32:37
 * @Description: 
 * @FilePath: /hsylc2021/src/components/icons/Arrow/index.vue
-->
<template>
  <div class="icon-arrow" :class="computedClass" :style="componentStyle">
    <div class="arrow-content" :style="contentStyle"></div>
  </div>
</template>
<script>
/**
 * 箭头图标
 * @module Arrow
 */
export default {
  name: 'Arrow',
  /**
   * @prop {String} className 外部class
   * @prop {String} color 图标颜色 默认#20c25D
   * @prop {String} width 组件大小 默认24px
   * @prop {String} weight 线图粗细 默认2px
   * @prop {Number} percent 最长边对应组件宽度百分比 默认75
   */
  props: {
    className: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'right'
    },
    color: {
      type: String,
      default: '#7C7D80'
    },
    width: {
      type: String,
      default: '20px'
    },
    weight: {
      type: String,
      default: '2px'
    },
    percent: {
      type: Number,
      default: 60
    }
  },
  /**
   * @prop {Object} computedClass 计算后的class
   * @prop {Object} computedStyle 组件样式
   * @prop {Object} contentStyle 横线样式
   */
  computed: {
    computedClass() {
      let ret = {};
      ret[this.className] = true;
      ret[this.type] = true;
      return ret;
    },
    componentStyle() {
      let ret = {};
      ret.width = ret.height = this.width;
      return ret;
    },
    contentStyle() {
      let ret = {};
      ret.width = `${this.percent}%`;
      ret.height = `${this.percent}%`;
      ret.borderWidth = this.weight;
      ret.borderColor = this.color;
      return ret;
    }
  }
};
</script>
<style lang="less" scoped>
.icon-arrow {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.3s;
  .arrow-content {
    border-style: solid;
    border-top: 0;
    border-right: 0;
    transform: rotate(225deg);
  }
  &.left {
    .arrow-content {
      transform: rotate(45deg);
    }
  }
  &.down {
    .arrow-content {
      transform: translateY(-25%) rotate(-45deg);
    }
  }
  &.up {
    .arrow-content {
      transform: translateY(25%) rotate(135deg);
    }
  }
}
</style>
